export const POST_CHECKOUT = 'POST_CHECKOUT';
export const LIST_CHECKOUT = 'LIST_CHECKOUT';
